export class ResponsePoliticaTermo {

    private uuid: string;
    private usuarioId: number;
    private dataAceite: string;
    private termoAceito: boolean;
    private privacidadeAceita: boolean;

    public getUuid(): string {
        return this.uuid;
    }

    public setUuid(uuid: string): void {
        this.uuid = uuid;
    }

    public getUsuarioId(): number {
        return this.usuarioId;
    }

    public setUsuarioId(usuarioId: number): void {
        this.usuarioId = usuarioId;
    }

    public getDataAceite(): string {
        return this.dataAceite;
    }

    public setDataAceite(dataAceite: string): void {
        this.dataAceite = dataAceite;
    }

    public isTermoAceito(): boolean {
        return this.termoAceito;
    }

    public setTermoAceito(termoAceito: boolean): void {
        this.termoAceito = termoAceito;
    }

    public isPrivacidadeAceita(): boolean {
        return this.privacidadeAceita;
    }

    public setPrivacidadeAceita(privacidadeAceita: boolean): void {
        this.privacidadeAceita = privacidadeAceita;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/ResponsePoliticaTermo.ts